import { GET_CONFIGURATIONS } from "constants/configurations";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_CONFIGURATIONS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
